// eslint-disable-next-line import/prefer-default-export
export const ERROR_CODES = {
  unauthorized: 401,
  notFound: 404,
};
